import { Icon } from '#app/components/ui/icon'
import { Input } from '#app/components/ui/input'
import { Label } from '#app/components/ui/label'
import { cn } from '#app/utils/misc'

interface SearchInputProps extends React.HTMLAttributes<HTMLInputElement> {
	placeholder: string
}

const SearchInput = ({
	id,
	className,
	defaultValue,
	placeholder,
	onChange,
	...rest
}: SearchInputProps) => {
	return (
		<div className="flex-1">
			<Label htmlFor={id} className="sr-only">
				{id || 'Search'}
			</Label>

			<div className={cn('relative flex w-full items-center', className)}>
				<Icon
					className="text-body-md absolute left-4 text-beige-100"
					size="lg"
					name="magnifying-glass"
				/>
				<Input
					type="search"
					name="terms"
					defaultValue={defaultValue}
					placeholder={placeholder}
					className={cn(
						'w-full rounded-3xl border border-beige-90 border-input bg-white py-4 pl-12 pr-6 ring-offset-background placeholder:text-muted-foreground placeholder:opacity-20 focus:outline focus:outline-1 focus:outline-green-90',
					)}
					onChange={onChange}
					{...rest}
				/>
			</div>
		</div>
	)
}

export default SearchInput
